<template>
  <!-- Home Section 03 -->

  <section class="home-page" style="overflow: hidden;">
    <div class="site-wrapper">
      <!-- Hero Area  -->
      <section class>
        <div>
          <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
              <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
              <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
              <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
            </ol>
            <div class="carousel-inner">
              <!--First v-scrollanimation-left  Image -->
              <div class="carousel-item active" data-aos="fade-left">
                <img
                  class="w-100 img-responsive intropage"
                  src="/assets/exported/slide_img_1.jpg"
                  alt="First slide"
                  height="100%"
                />
                <img
                  class="w-100 img-responsive intropage mobile"
                  src="/assets/exported/mobile/banner_mobile_2.jpg"
                  alt="First slide"
                  height="100%"
                />
                <div class="carousel-caption d-none d-md-block">
                  <h5>{{$root.home_img_1.head}}</h5>
                  <h4>{{$root.home_img_1_subhead.sub_head}}</h4>
                  <div class="row_home_right zoom">
                    <span>
                      <a class href="/course_description">{{$root.home_img.button_text}}</a>
                      <i
                        class="fa fa-arrow-right"
                        style="margin-left:4px;font-weight:600"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
              <!--Second v -scrollanimation-right  Image -->

              <div class="carousel-item">
                <img
                  class="w-100 img-responsive intropage"
                  src="/assets/exported/slide_img_2.jpg"
                  alt="Second slide"
                />
                <img
                  class="w-100 img-responsive intropage mobile"
                  src="/assets/exported/mobile/banner_mobile_3.jpg"
                  alt="Second slide"
                />
                <div class="carousel-caption d-none d-md-block">
                  <h5>{{$root.home_img_2.head}}</h5>
                  <h4>{{$root.home_img_2_subhead.sub_head}}</h4>
                  <p>{{$root.home_img_2_subsubhead.sub_sub_head}}</p>
                  <div class="row_home_right zoom">
                    <span>
                      <a href="/course_description">{{$root.home_img.button_text}}</a>
                      <i
                        class="fa fa-arrow-right"
                        style="margin-left:4px;font-weight:600"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
              <!--Third Image v-scrollanimation-left -->
              <div class="carousel-item">
                <img
                  class="w-100 img-responsive intropage"
                  src="/assets/exported/slide_img_3.jpg"
                  alt="Third slide"
                />
                <img
                  class="w-100 img-responsive intropage mobile"
                  src="/assets/exported/mobile/banner_mobile_1.jpg"
                  alt="Third slide"
                />
                <div class="carousel-caption d-none d-md-block">
                  <h5>{{$root.home_img_3.head}}</h5>
                  <h4>{{$root.home_img_3_subhead.sub_head}}</h4>
                  <p>{{$root.home_img_3_subsubhead.sub_sub_head}}</p>
                  <div class="row_home_right zoom">
                    <span>
                      <a href="/course_description">{{$root.home_img.button_text}}</a>
                      <i
                        class="fa fa-arrow-right"
                        style="margin-left:4px;font-weight:600"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--<p class="mt-4">
                Slide #: {{ slide }}<br>
                Sliding: {{ sliding }}
                <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
                </a>
          </p>-->
        </div>
      </section>
      <!-- Features Area  v-scrollanimation- v-scrollanimation-left -scrollanimation-right-->
      <section class="content-section-01 home_1" style="background-color:#FFF;">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-sm-6 col-10">
              <div class="content-img" data-aos="fade-right">
                <img src="/assets/exported/image-1.png" alt />
              </div>
            </div>
            <div class="col-xl-5 offset-xl-1 col-sm-6">
              <div class="content-right-content" data-aos="fade-left">
                <h2>{{$root.home_body.left_head}}</h2>
                <p>{{$root.home_body_text.left_head_text}}</p>
                <h2>{{$root.home_body_sub.left_head_sub}}</h2>
                <span>
                  <a>
                    <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  </a>
                  <p class="p_home_text">{{$root.home_body_sub_text.left_head_sub_text}}</p>
                </span>
                <br />
                <span>
                  <a>
                    <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  </a>
                  <p class="p_home_text">{{$root.home_body_sub_text1.left_head_sub_text1}}</p>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        class="content-section-02 home_course home_1"
        data-aos="zoom-in-up"
        style="background-color:#F9F9F9;"
      >
        <div class="container course_hero">
          <h2>{{$root.h_body_r.r_course}}</h2>
          <div
            class="course_list_menu_home"
            v-for="(modules, d_index) in nutrition"
            :key="d_index"
            :value="modules.id"
          >
            <img :src="modules.picture_url" alt />
            <div class>
              <div class="row_course">
                <h2>{{modules.name }}</h2>
                <p>{{ modules.module_count }} {{$root.module_count.r_modules}}</p>
                <div class="row_course_right offset-xl-1 zoom">
                  <a @click="coursePage()" class="zoom">{{$root.h_body_b.r_button}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="content-section-02 home_1" style="background-color:#FFF;margin-top:40px;">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-sm-6 offset-xl-2 col-10 order-sm-2">
              <div class="content-img_1 md_img" data-aos="fade-right">
                <img src="/assets/exported/image-2.png" alt style />
              </div>
            </div>
            <div class="col-xl-5 offset-xl-0 col-sm-6 order-sm-1">
              <div class="content-left-content" data-aos="fade-left">
                <h2>{{$root.h_body_l.l_head}}</h2>
                <p>{{$root.h_body_l_p.l_head_p}}</p>
                <ul class="content-list">
                  <li class="content-list_slide zoom">
                    <span>
                      <a
                        href="/Guideline.pdf"
                        target="_blank"
                      >{{$root.h_body_b2.l_head_b}}</a>
                      <i class="fa fa-arrow-right" aria-hidden="true"></i>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="content-section-03 home_1" style="background-color:#FFF">
        <div class="shape_1">
          <img src alt />
        </div>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-5 col-sm-6 col-10">
              <div class="content-img" style="width=80%;" data-aos="fade-right">
                <img src="/assets/exported/image-3.png" alt style="width:85%" />
              </div>
            </div>
            <div class="col-xl-5 offset-xl-1 col-lg-6 col-md-7 col-sm-6">
              <div class="content-left-content" style="margin-top:70px;" data-aos="fade-left">
                <h2>{{$root.h_body_right2.right_head2}}</h2>
                <p>{{$root.h_body_right2_p.right_head2_p}}</p>
                <div class="content-btn">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.riseuplabs.onlinenutrition"
                    class
                    target="blank"
                  >
                    <img src="/assets/exported/google.png" style="width:80%;" alt />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script src="../js/active.js"></script>
<script>
import axios from "axios";
export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      nutrition: [],
    };
  },
  components: {},
  mounted() {
    this.reloadAPI();
    this.$root.page_hook = this;
  },
  methods: {
    openTab(th) {
      window.open(th.name, "_blank");
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    reloadAPI() {
      // Get Data From Offline
      if (!navigator.onLine) {
        if (window.localStorage.getItem("getcourse") != null) {
          console.log("Local Data: getcourse");
          var localData = JSON.parse(window.localStorage.getItem("getcourse"));
          this.nutrition = localData;
          return;
        }
      }
      var config = {
        headers: {
          "X-localization": this.$root.translate ? "bn" : "en",
        },
      };
      axios
        .get(this.$root.API_BASE_URL + "getcourse", config)
        .then((response) => {
          // Response received From Server
          // this.isLoading = false;

          if (response.data == []) {
            // Blank
            return;
          }
          this.nutrition = response.data.data;
          // Save Locally
          localStorage.setItem("getcourse", JSON.stringify(response.data.data));
        });
    },
    coursePage() {
      if (this.$root.logged_in == false) {
        this.$router.push({ path: "/login" });
      } else {
        this.$router.push({ path: "/course_description" });
      }
    },
  },
  beforeMount() {},
  beforeDestroy() {
    this.$root.page_hook = null;
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.intropage {
  margin-top: 50px;
}
.parallax::after {
  /* Display and position the pseudo-element */
  content: " ";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* Move the pseudo-element back away from the camera,
   * then scale it back up to fill the viewport.
   * Because the pseudo-element is further away, it appears to move more slowly, like in real life. */
  transform: translateZ(-1px) scale(1.5);
  /* Force the background image to fill the whole element. */
  background-size: 100%;
  /* Keep the image from overlapping sibling elements. */
  z-index: -1;
}
.md_img {
  margin-left: -8%;
}
.content-img_1 img {
  max-width: 105%;
  margin-top: -15px;
}
.content-right-content a {
  color: #005a06;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #005a06;
  display: block;
  line-height: 13px;
  margin-left: 0px;
  padding: 0px 0px 0px 0.2px;
  text-align: center;
  font-size: 9px;
  -webkit-transition: all 0.3s linear;
  transition: all 0.3s linear;
  font-weight: bold;
}
.p_home_text {
  margin-left: 25px;
}
/*
    This classes are for the directive. 
    For each element observed by our directive, the before-enter class is added.
  */
.before-enter {
  opacity: 1;
  transform: scale(1) translateY(200px);
  transition: all 2s ease-out;
}
/* 
    If the element intersects with the viewport, the before-enter class is added.
  */
.enter {
  opacity: 1;
  transform: scale(1) translateY(0px);
}
.before-enter-left {
  opacity: 0;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  transition: all 1s ease-out;
}
/* 
    If the element intersects with the viewport, the before-enter class is added.
  */
.enter-left {
  opacity: 1;
  transform: scale(1) rotateZ(0deg);
}
.fade-right {
  opacity: 0;
  -webkit-transform: translate(+50%, +50%);
  -ms-transform: translate(+50%, +50%);
  transform: translate(+50%, +50%);
  transition: all 1s ease-out;
}
/* 
    If the element intersects with the viewport, the before-enter class is added.
  */
.fade-right_entr {
  opacity: 1;
  transform: scale(1) rotateZ(0deg);
}
.content-left-content {
  transition-delay: 0.1s;
}
@media screen and (max-width: 480px) {
  .intropage {
    margin-top: 10px;
  }
}
</style>